import React, { useState, useEffect } from 'react';

import {
    Button, Dialog, Box, Grid, makeStyles, DialogTitle, DialogContent,
    FormControl, Select, InputLabel, TextField,
    CircularProgress, MenuItem,
    OutlinedInput,
} from '@material-ui/core';

import { CustomToast } from '@jumbo/components/custom/Toast';

import { formatRut, LABEL_INPUT_FONT_SIZE, validateRut } from 'routes/Pages/FichasTecnicas/ConstsAndUtils/utils';
import { EXCLUDE_FROM_ODONTOLOGIA, PRIVADOS, TEXT_COLOR_FT } from 'config/config';
import GridContainer from '@jumbo/components/GridContainer';
import { Autocomplete } from '@mui/material';
import { Save } from '@material-ui/icons';

const addStyle = makeStyles(theme => ({
    dialogRoot: {
        position: 'relative',
    },
    dialogTitleRoot: {
        '& .MuiTypography-h6': {
            fontSize: 16,
            color: theme.palette.common.dark,
        },
    },
}));

const EditModal2 = props => {
    const {
        openDialog = false,
        close,
        dataCrear,
        postData,
        autoridades,
    } = props;

    const [loading, setIsLoading] = useState(false);
    const [formData, setFormData] = useState(dataCrear || {});
    const classes = addStyle();

    // Cuando cambie la fila seleccionada o se abra el modal,
    // sincronizamos el estado local con dataCrear
    useEffect(() => {
        setFormData(dataCrear || {});
    }, [dataCrear, openDialog]);

    const onCloseDialog = (event, reason) => {
        if (reason !== 'backdropClick') {
            clearData();
            close();
        }
    };

    const clearData = () => {
        setIsLoading(false);
    };

    const handleChange = (field) => (event) => {
        const value = event.target.value;
        setFormData(prev => ({
            ...prev,
            [field]: value,
        }));
    };

    const validateForm = () => {

        return false;
    };

    const selectedCodigoOption =
        autoridades.find(opt => opt.label === formData.nom_autoridad) || null;

    return (
        <Dialog open={openDialog} onClose={onCloseDialog}>
            <CustomToast />
            <DialogTitle className={classes.dialogTitleRoot}>
                <Grid container justifyContent='space-between' style={{ color: TEXT_COLOR_FT }}>
                    <Grid item >
                        {formData?.nombre ? 'Editar ' + formData.nom_equipo : 'Editar registro'}
                    </Grid>
                </Grid>
            </DialogTitle>
            <DialogContent dividers>
                <Box
                    display="flex"
                    flexDirection={{ xs: 'column', md: 'row' }}
                    alignItems="center"
                    mb={{ xs: 6, md: 5 }}
                >

                    <GridContainer>



                        {/* Nº Autorización sanitaria */}
                        <Grid item xs={12} md={6}>
                            <TextField
                                fullWidth
                                margin="dense"
                                variant="outlined"
                                label="Nº Autorización sanitaria"
                                value={formData.nro_resolucion || ''}
                                onChange={handleChange('nro_resolucion')}
                                InputLabelProps={{
                                    shrink: true,
                                    style: { fontSize: LABEL_INPUT_FONT_SIZE },
                                }}
                            />
                        </Grid>

                        {/* Fecha Resolución */}
                        <Grid item xs={12} md={6}>
                            <TextField
                                fullWidth
                                type='date'
                                margin="dense"
                                variant="outlined"
                                label="Fecha Resolución"
                                placeholder="dd/mm/aaaa"
                                value={formData.fecha_resolucion || ''}
                                onChange={handleChange('fecha_resolucion')}
                                InputLabelProps={{
                                    shrink: true,
                                    style: { fontSize: LABEL_INPUT_FONT_SIZE },
                                }}
                                inputProps={{
                                    maxLength: 10,
                                }}
                            />
                        </Grid>

                        {/* Autoridad que otorga */}
                        <Grid item xs={12} md={12}>
                            <Autocomplete

                                options={autoridades}
                                value={selectedCodigoOption}
                                getOptionLabel={option =>
                                    option ? `${option.label}` : ''
                                }
                                onChange={(event, newValue) => {
                                   
                                    setFormData(prev => ({
                                        ...prev,
                                        nom_autoridad: newValue ? newValue.label : '',
                                        // guardamos descripción internamente, aunque ya no haya campo visible
                                        id_autoridad: newValue ? newValue.value : '',

                                    }));
                                }}
                                renderInput={params => (
                                    <TextField
                                        {...params}
                                        fullWidth
                                        size='small'
                                        variant="outlined"
                                        label="Autoridad que otorga"
                                        InputLabelProps={{
                                            shrink: true,
                                            style: { fontSize: LABEL_INPUT_FONT_SIZE },
                                        }}
                                    />
                                )}
                            />
                        </Grid>

                    </GridContainer>


                </Box>

                <Box display="flex" justifyContent="flex-end" mb={4}>
                    <Button onClick={onCloseDialog} disabled={loading} variant='outlined'>
                        Cerrar
                    </Button>
                    <Box ml={2}>
                        <Button
                            variant="outlined"
                            color="primary"
                            onClick={() => {
                                //setIsLoading(true);
                                postData(formData);
                            }}
                            disabled={validateForm() || loading}
                        >
                        <Save style={{marginRight:10}} />
                            {loading ? (
                                <CircularProgress
                                    color="inherit"
                                    style={{ height: '22px', width: '22px' }}
                                />
                            ) : (
                                'Actualizar'
                            )}
                        </Button>
                    </Box>
                </Box>
            </DialogContent>
        </Dialog>
    );
};

export default EditModal2;

